import React, { Children, cloneElement, isValidElement, memo, useContext } from 'react';
import RippleChild from './RippleChild';
import createChains from '../_util/createChains';
import ConfigContext from '../config-provider/ConfigContext';
const Ripple = function Ripple(props) {
    const { prefixCls: customizePrefixCls, disabled, children, ...rest } = props;
    const { getPrefixCls, getConfig } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('ripple', customizePrefixCls);
    const rippleChild = (child) => {
        return React.createElement(RippleChild, Object.assign({ prefixCls: prefixCls }, rest), child);
    };
    if (disabled || !children || !getConfig('ripple')) {
        if (children) {
            return React.createElement(React.Fragment, null, Children.map(children, child => isValidElement(child) ? cloneElement(child, createChains(rest, child.props)) : child));
        }
        return null;
    }
    return React.createElement(React.Fragment, null, Children.map(children, (child) => rippleChild(child)));
};
Ripple.displayName = 'Ripple';
export default memo(Ripple);
